import { z } from "zod"

const numberOrStringSchema = z.union([z.number(), z.string()])
const stringOrDateSchema = z.union([z.string(), z.date()])

export const readingDataSchema = z.intersection(
  z.object({
    keyName: z.string().optional(),
    fromDateTime: stringOrDateSchema,
    toDateTime: stringOrDateSchema,
    duration: z.number().optional(),
    timeAccuracy: z.number().optional(),
    quantityUnit: z.string(),
    quantityAccuracy: z.number().optional(),
    touType: z
      .enum([`CRITICAL_PEAK`, `OFF_PEAK`, `ON_PEAK`, `PARTIAL_PEAK`])
      .optional(),
  }),
  z.union([
    z.object({
      importQuantityValue: numberOrStringSchema,
    }),
    z.object({
      exportQuantityValue: numberOrStringSchema,
    }),
    z.object({
      /** positive if charging the battery */
      importQuantityValue: numberOrStringSchema,
      /** positive if discharging the battery */
      exportQuantityValue: numberOrStringSchema,
    }),
  ]),
)

export type ReadingData = z.infer<typeof readingDataSchema>

export type SerializableReadingData = Omit<
  ReadingData,
  `fromDateTime` | `toDateTime`
> & {
  fromDateTime: string
  toDateTime: string
}

export const processReadingData = (
  readingData: ReadingData[],
): SerializableReadingData[] =>
  readingData.map<SerializableReadingData>(
    ({ fromDateTime, toDateTime, ...data }) => ({
      ...data,
      fromDateTime:
        fromDateTime instanceof Date ? fromDateTime.toISOString() : fromDateTime,
      toDateTime:
        toDateTime instanceof Date ? toDateTime.toISOString() : toDateTime,
    }),
  )
